import { position } from '../types';
import preset from '../preset';

export const positionClass = preset.xclasses<position>('position');

export default positionClass;
